var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 7,
    viewBox: "0 0 14 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9133 0.183988L7.44768 5.56317C7.32843 5.68114 7.16745 5.74731 6.9997 5.74731C6.83195 5.74731 6.67097 5.68114 6.55172 5.56317L1.08615 0.185154C0.966156 0.0672391 0.804652 0.00116757 0.636419 0.00116756C0.468186 0.00116754 0.306682 0.067239 0.18669 0.185154C0.127603 0.242757 0.0806442 0.311604 0.0485817 0.387639C0.0165192 0.463674 5.64283e-07 0.545359 5.57069e-07 0.627877C5.49855e-07 0.710396 0.0165191 0.79208 0.0485817 0.868115C0.0806442 0.94415 0.127603 1.013 0.18669 1.0706L5.6511 6.44861C6.01102 6.80201 6.49528 7 6.9997 7C7.50412 7 7.98838 6.80201 8.3483 6.44861L13.8127 1.0706C13.872 1.01298 13.9191 0.944061 13.9513 0.867918C13.9834 0.791775 14 0.709954 14 0.627295C14 0.544635 13.9834 0.462816 13.9513 0.386673C13.9191 0.31053 13.872 0.241609 13.8127 0.183988C13.6927 0.0660734 13.5312 1.38953e-06 13.363 1.37482e-06C13.1947 1.36011e-06 13.0332 0.0660733 12.9133 0.183988Z",
    fill: "#334456"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdown);
export default __webpack_public_path__ + "static/media/arrowdown.321261a38a04843d8385ed5bb59cc3da.svg";
export { ForwardRef as ReactComponent };